<template>
    <design-2021-apprentice-google-map-component :address="address"
                                                 :title="title"
                                                 :google-map-api="googleMapApi"
                                                 :height="height">
        <template v-slot="{ google, map, googleMapApi, marker, address, title }">
            <design-2021-apprentice-google-map-marker-component :title="title"
                                                                :google="google"
                                                                :map="map"
                                                                :google-map-api="googleMapApi"
                                                                :marker="marker"
                                                                :address="address">
            </design-2021-apprentice-google-map-marker-component>
        </template>
    </design-2021-apprentice-google-map-component>
</template>

<script>
export default {
    name: "design-2021-apprentice-map-component",
    props: {
        address: {
            type: Object,
            required: true,
            validator: function(value){
                return 'street' in value && 'number' in value && 'zipcode' in value && 'location' in value;
            }
        },

        title: {
            type: String,
            required: true,
        },

        googleMapApi:  {
            type: String,
            required: true,
        },

        height: {
            type: Number,
            required: false,
            default: 200,
        }
    },
}
</script>

<style scoped>

</style>
